import { Modal, Box, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useState, useEffect } from "react";
import useCreateOrganizationProposalChecklistItem from "hooks/organization/useCreateOrganizationProposalChecklistItem";

interface CreateChecklistItemModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: (newItem: { id: string; name: string }) => void;
}

export default function CreateChecklistItemModal({
  open,
  onClose,
  onSuccess,
}: CreateChecklistItemModalProps) {
  const [createChecklistItem, { loading: isCreating }] =
    useCreateOrganizationProposalChecklistItem();
  const [newItemName, setNewItemName] = useState("");

  useEffect(() => {
    if (open) {
      setNewItemName("");
    }
  }, [open]);

  const handleClose = () => {
    setNewItemName("");
    onClose();
  };

  const handleSave = async () => {
    if (!newItemName.trim()) return;

    const result = await createChecklistItem({
      variables: {
        name: newItemName.trim(),
      },
    });

    if (onSuccess && result.data?.createOrganizationProposalChecklistItem) {
      onSuccess({
        id: result.data.createOrganizationProposalChecklistItem.id,
        name: result.data.createOrganizationProposalChecklistItem.name,
      });
    }
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="create-item-modal-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxWidth: "90%",
          bgcolor: "background.paper",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <MDTypography id="create-item-modal-title" variant="h6" mb={3}>
          Create New Checklist Item
        </MDTypography>

        <MDBox mb={3}>
          <TextField
            fullWidth
            label="Item Name"
            placeholder="Enter checklist item name..."
            value={newItemName}
            onChange={(e) => setNewItemName(e.target.value)}
            variant="outlined"
            autoFocus
          />
        </MDBox>

        <MDBox display="flex" justifyContent="flex-end" gap={2}>
          <MDButton
            onClick={handleClose}
            color="secondary"
            variant="outlined"
            disabled={isCreating}
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={handleSave}
            color="success"
            variant="contained"
            disabled={!newItemName.trim() || isCreating}
          >
            {isCreating ? "Creating..." : "Create"}
          </MDButton>
        </MDBox>
      </Box>
    </Modal>
  );
}
